import React from 'react';
import AppShell from '../components/AppShell';
import SettingsTab from '../components/dash/SettingsTab';
import { useMe, useFlash } from '../lib/useMe';

export default function SettingsPage() {
  const [me, setMe] = useMe();
  const flash = useFlash();
  if (!me) return <AppShell title="Settings"><p style={{ color: 'var(--muted)' }}>Loading…</p></AppShell>;
  return (
    <AppShell title="Settings" subtitle="Your account details and password. These stay private." testid="settings-page">
      <SettingsTab me={me} setMe={setMe} flash={flash} />
    </AppShell>
  );
}
